import { Component, HostListener, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { AppMenuItem as MenuItem } from '@/layout/model/menu-item.model';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LayoutService } from '@/layout/service/layout.service';
import { CuiAvatarComponent } from '@idealink-material/ui-core';
import { AppBreadcrumb } from '@/layout/components/app.breadcrumb';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotificationComponent } from '@/share/component/notification/notification.component';
import { NotificationService } from '@/share/services/notification-service';
import { AppI18nService } from '@/core/service/app-i18n-service';
import { BreadCrumbService } from '@/core/service/bread-crumb.service';
import { TranslatePipe } from '@ngx-translate/core';
import { DateTimesPipe } from '@/core/pipe/date-times.pipe';
import { AuthService } from '@/core/service/auth.service';

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, CommonModule, AppBreadcrumb, CuiAvatarComponent, NotificationComponent, TranslatePipe, DateTimesPipe],
    template: `
        <div class="layout-topbar pr-5">
            <div class=" h-full flex items-center justify-center bg-neutral-800 w-[7rem] rounded-tr-3xl">
                <a class="my-3">
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.5938 22.6689C13.5938 22.2687 13.6645 21.9547 13.8073 21.7298C13.9502 21.5049 14.1284 21.3408 14.342 21.2418L31.5189 13.2007C31.608 13.1498 31.6887 13.1257 31.7594 13.1257C31.9192 13.1257 32.0536 13.2007 32.1611 13.352C32.2686 13.502 32.3209 13.6901 32.3209 13.915V17.2219C32.3209 17.5727 32.2544 17.8415 32.1201 18.0296C31.9857 18.2177 31.857 18.3365 31.7325 18.386L17.953 24.7354L31.7325 31.0481C31.857 31.123 31.9871 31.2546 32.1201 31.4427C32.2544 31.6308 32.3209 31.8996 32.3209 32.2503V35.5559C32.3209 35.7567 32.2672 35.9378 32.1611 36.1004C32.0536 36.2631 31.9206 36.3451 31.7594 36.3451C31.6872 36.3451 31.608 36.3197 31.5189 36.2702L14.342 28.2291C14.1284 28.1287 13.9488 27.966 13.8073 27.7411C13.6645 27.5148 13.5938 27.2022 13.5938 26.8019V22.6689Z"
                            fill="#3345C4"
                        />
                        <path
                            d="M38.9405 46.539C38.6307 46.7936 38.3436 46.9379 38.0791 46.9704C37.8146 47.0029 37.5741 46.9704 37.362 46.8671L20.2388 38.7129C20.1426 38.6761 20.0733 38.6295 20.028 38.5743C19.9262 38.4498 19.8993 38.2999 19.9474 38.1217C19.9955 37.9435 20.1058 37.7822 20.2798 37.6394L22.8329 35.5375C23.103 35.3154 23.3548 35.1952 23.5839 35.1796C23.8145 35.1641 23.9885 35.1881 24.1059 35.2518L37.7651 41.8558L33.8839 27.205C33.8626 27.0608 33.8824 26.8769 33.9419 26.6548C34.0027 26.4328 34.1668 26.2093 34.4383 25.9872L36.9914 23.8854C37.1456 23.7581 37.3195 23.6845 37.5147 23.6633C37.7085 23.6421 37.857 23.6944 37.9589 23.8175C38.0041 23.8726 38.0352 23.9504 38.0536 24.0508L42.7595 42.423C42.8175 42.6521 42.8061 42.8926 42.7227 43.1472C42.6392 43.4004 42.4426 43.655 42.1329 43.9096L38.9419 46.5362V46.539H38.9405Z"
                            fill="#3345C4"
                        />
                        <path
                            d="M45.3748 15.0635C45.7383 15.2318 45.9929 15.427 46.1386 15.6505C46.2828 15.874 46.3564 16.1045 46.3578 16.3407L46.4681 35.3069C46.4766 35.4088 46.4653 35.4922 46.4356 35.5573C46.3677 35.703 46.2446 35.7935 46.0622 35.8274C45.8811 35.8614 45.6874 35.8317 45.4837 35.7369L42.4808 34.3522C42.1626 34.2051 41.9462 34.0325 41.8316 33.8317C41.717 33.6322 41.6633 33.4639 41.6703 33.3296L41.6732 18.1583L30.171 28.0282C30.0507 28.1103 29.8768 28.1725 29.6505 28.2149C29.4241 28.2574 29.1512 28.2065 28.8329 28.0594L25.8301 26.6746C25.6476 26.5912 25.5062 26.4667 25.4015 26.3012C25.2996 26.1357 25.2813 25.9801 25.3477 25.8344C25.3774 25.7694 25.434 25.7071 25.5175 25.6477L40.0112 13.4157C40.1923 13.2629 40.4143 13.1696 40.6788 13.1342C40.9433 13.0988 41.2573 13.1653 41.6223 13.3336L45.3762 15.0649L45.3748 15.0635Z"
                            fill="#3345C4"
                        />
                    </svg>
                </a>
            </div>

            <!--            <button #menubutton class="topbar-menubutton p-link" type="button" (click)="onMenuButtonClick()">-->
            <!--                <span></span>-->
            <!--            </button>-->
            <div class="px-[1.2rem]">
                <a class="layout-topbar-logo">
                    <app-breadcrumb></app-breadcrumb>
                </a>
            </div>
            <div class="topbar-actions">
                <div class="relative h-7 w-7">
                    <button class="topbar-icon-btn cursor-pointer" (click)="togglePopover('language', $event)">
                        <span [innerHTML]="currentFlag"></span>
                    </button>
                    @if (activePopover() === 'language') {
                        <div class="absolute right-0 top-full mt-2 w-[220px] min-w-[200px] max-w-[220px] bg-white rounded-2xl shadow-lg border border-[#E6E6E6] z-50 p-5 space-y-5" (click)="$event.stopPropagation()">
                            @for (item of languageItems; track item.value) {
                                <a class="flex items-center px-3 py-2 rounded-lg cursor-pointer"
                                   [class.font-bold]="item.value === i18n.currentLang()"
                                   [style.background]="item.value === i18n.currentLang() ? '#F3F3F7' : null"
                                   (click)="runCommand(item)">
                                    <span [innerHTML]="item.icon"></span>
                                    <span class="ml-2">{{ item.label | translate }}</span>
                                    @if (item.value === i18n.currentLang()) {
                                        <span class="ml-auto material-symbols-outlined  text-primary">check</span>
                                    }
                                </a>
                            }
                        </div>
                    }
                </div>
                <div class="h-7 w-7 relative">
                    <button class="topbar-icon-btn cursor-pointer" (click)="togglePopover('notification', $event)">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.024 3.39502C10.1624 3.39502 7.02405 6.53335 7.02405 10.395V13.7667C7.02405 14.4784 6.72071 15.5634 6.35905 16.17L5.01738 18.3984C4.18905 19.775 4.76071 21.3034 6.27738 21.8167C11.3057 23.4967 16.7307 23.4967 21.759 21.8167C23.1707 21.35 23.789 19.6817 23.019 18.3984L21.6774 16.17C21.3274 15.5634 21.024 14.4784 21.024 13.7667V10.395C21.024 6.54502 17.874 3.39502 14.024 3.39502Z"
                                stroke="#B3B3B3"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                            />
                            <path
                                d="M16.1817 3.73343C15.82 3.62843 15.4467 3.54676 15.0617 3.50009C13.9417 3.36009 12.8683 3.44176 11.865 3.73343C12.2033 2.87009 13.0433 2.26343 14.0233 2.26343C15.0033 2.26343 15.8433 2.87009 16.1817 3.73343Z"
                                stroke="#B3B3B3"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M17.5228 22.2366C17.5228 24.1616 15.9478 25.7366 14.0228 25.7366C13.0662 25.7366 12.1795 25.3399 11.5495 24.7099C10.9195 24.0799 10.5228 23.1932 10.5228 22.2366"
                                stroke="#B3B3B3"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                            />
                        </svg>
                    </button>
                    @if (activePopover() === 'notification') {
                        <div class="absolute right-0 top-full mt-2 z-50 w-[370px] bg-white rounded-2xl shadow-lg overflow-hidden" (click)="$event.stopPropagation()">
                            <app-notification></app-notification>
                        </div>
                    }
                </div>

                <div class="h-7 w-7 relative" id="setting">
                    <button class="topbar-icon-btn cursor-pointer" (click)="togglePopover('setting', $event)">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14 17.5C15.933 17.5 17.5 15.933 17.5 14C17.5 12.067 15.933 10.5 14 10.5C12.067 10.5 10.5 12.067 10.5 14C10.5 15.933 12.067 17.5 14 17.5Z"
                                stroke="#B3B3B3"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M2.33337 15.0268V12.9734C2.33337 11.7601 3.32504 10.7568 4.55004 10.7568C6.66171 10.7568 7.52504 9.26342 6.46337 7.43176C5.85671 6.38176 6.21837 5.01676 7.28004 4.41009L9.29837 3.25509C10.22 2.70676 11.41 3.03342 11.9584 3.95509L12.0867 4.17676C13.1367 6.00842 14.8634 6.00842 15.925 4.17676L16.0534 3.95509C16.6017 3.03342 17.7917 2.70676 18.7134 3.25509L20.7317 4.41009C21.7934 5.01676 22.155 6.38176 21.5484 7.43176C20.4867 9.26342 21.35 10.7568 23.4617 10.7568C24.675 10.7568 25.6784 11.7484 25.6784 12.9734V15.0268C25.6784 16.2401 24.6867 17.2434 23.4617 17.2434C21.35 17.2434 20.4867 18.7368 21.5484 20.5684C22.155 21.6301 21.7934 22.9834 20.7317 23.5901L18.7134 24.7451C17.7917 25.2934 16.6017 24.9668 16.0534 24.0451L15.925 23.8234C14.875 21.9918 13.1484 21.9918 12.0867 23.8234L11.9584 24.0451C11.41 24.9668 10.22 25.2934 9.29837 24.7451L7.28004 23.5901C6.21837 22.9834 5.85671 21.6184 6.46337 20.5684C7.52504 18.7368 6.66171 17.2434 4.55004 17.2434C3.32504 17.2434 2.33337 16.2401 2.33337 15.0268Z"
                                stroke="#B3B3B3"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                    @if (activePopover() === 'setting') {
                        <div class="absolute right-0 top-full mt-2 w-[220px] min-w-[200px] max-w-[220px] bg-white rounded-2xl shadow-lg border border-[#E6E6E6] z-50 flex flex-col p-4 gap-4" (click)="$event.stopPropagation()">
                            <div class="flex items-center">
                                <p-avatar src="https://primefaces.org/cdn/primeng/images/demo/avatar/amyelsner.png" class="mr-2" shape="circle" />
                                <span class="inline-flex flex-col">
                                    <span class="font-bold">Amy Elsner</span>
                                    <span class="text-sm text-gray-400">Admin</span>
                                </span>
                            </div>
                            @for (item of settingItems; track $index) {
                                @if (item.separator) {
                                    <div class="-mx-4 border-t border-[#E6E6E6]"></div>
                                } @else {
                                    <a class="flex items-center cursor-pointer" (click)="runCommand(item)">
                                        <span [innerHTML]="item.icon"></span>
                                        <span class="ml-2">{{ item.label | translate }}</span>
                                        @if (item.value) {
                                            <small class="ml-1 text-gray-400">{{ item.value | dateTime }}</small>
                                        }
                                        @if (item.shortcut) {
                                            <span class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">{{ item.shortcut }}</span>
                                        }
                                    </a>
                                }
                            }
                        </div>
                    }
                </div>
                <div class="topbar-icon-btn h-7 w-7">
                    <img src="assets/images/profile.png" class="w-full h-full object-contain rounded-full" alt="" />
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            .topbar-icon-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 1.75rem;
                height: 1.75rem;
            }

            .topbar-icon-btn svg {
                width: 24px;
                height: 24px;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        class: 'layout-topbar'
    }
})
export class AppTopbar implements OnInit {
    menu: MenuItem[] = [];
    settingItems: any[] | undefined;
    languageItems: any[] = [];
    // @ViewChild('searchinput') searchInput!: ElementRef;

    // @ViewChild('menubutton') menuButton!: ElementRef;

    searchActive: boolean = false;
    readonly i18n = inject(AppI18nService);
    readonly authService = inject(AuthService);

    // ui-core has no PrimeNG-p-menu equivalent with a matching model shape
    // (popup + MenuItem[] + #item template), so these three popovers
    // (language/settings/notification) are hand-rolled: one signal tracks
    // which is open, clicks inside stopPropagation so only a genuine
    // outside click (caught by the document listener below) closes it.
    readonly activePopover = signal<'language' | 'setting' | 'notification' | null>(null);

    constructor(
        public layoutService: LayoutService,
        public sanitizer: DomSanitizer,
        private notifService: NotificationService
    ) {}

    togglePopover(name: 'language' | 'setting' | 'notification', event: Event): void {
        event.stopPropagation();
        this.activePopover.update((current) => (current === name ? null : name));
    }

    runCommand(item: MenuItem): void {
        item.command?.({ item });
        this.activePopover.set(null);
    }

    @HostListener('document:click')
    onDocumentClick(): void {
        this.activePopover.set(null);
    }

    ngOnInit() {
        this.languageItems = this.i18n.languages().map((lang) => ({
            label: `topbar.${lang.value}`,
            value: lang.value,
            icon: this.sanitize(lang.flagSvg),
            command: () => {
                this.i18n.switchLanguage(lang.value);
            }
        }));
        this.settingItems = [
            {
                separator: true
            },
            { label: 'topbar.lastLogin', value: new Date() },
            {
                separator: true
            },
            {
                label: 'topbar.logout',
                icon: this.sanitizer.bypassSecurityTrustHtml(`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.4395 14.62L19.9995 12.06L17.4395 9.5" stroke="#B3B3B3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.76001 12.0601H19.93" stroke="#B3B3B3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.76 20C7.34001 20 3.76001 17 3.76001 12C3.76001 7 7.34001 4 11.76 4" stroke="#B3B3B3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`),
                command: () => {
                    this.authService.logout();
                }
            }
        ];
    }

    sanitize(svg: string) {
        return this.sanitizer.bypassSecurityTrustHtml(svg);
    }

    get currentFlag(): SafeHtml {
        const lang = this.i18n.languages().find((l) => l.value === this.i18n.currentLang());
        return this.sanitize(lang?.flagSvg ?? '');
    }

    openNotification(event: Event) {
        this.notifService.open(event);
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    /* activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        }, 100);
    }*/

    deactivateSearch() {
        this.searchActive = false;
    }

    removeTab(event: MouseEvent, item: MenuItem, index: number) {
        this.layoutService.onTabClose(item, index);
        event.preventDefault();
    }

    get layoutTheme(): string | undefined {
        return this.layoutService.layoutConfig().layoutTheme;
    }

    set layoutTheme(value: string) {
        this.layoutService.layoutConfig.update((state) => ({ ...state, layoutTheme: value }));
    }

    get logo(): string {
        const path = '/layout/images/logo-';
        const logo = this.layoutService.isDarkTheme() || this.layoutService.layoutConfig().layoutTheme === 'primaryColor' ? 'light.png' : 'dark.png';
        return path + logo;
    }

    // get tabs(): MenuItem[] {
    //     return this.layoutService.tabs;
    // }

}
